<section class="news" id="news">
    <h2 class="section-title text-center text-white mb-5">{{ "news.title" | translate}}</h2>
    <div class="news-wrapper container d-none d-lg-block" *ngIf="!isMobile">
        <div class="row">
            <div class="col-md-3" *ngFor="let item of items; let i = index">
                <a class="news-box" [href]="item.link" target="_blank" rel="noopener noreferrer">
                    <div class="news-img mb-3">
                        <img [src]="item.img" alt="news image" class="img-fluid" loading="lazy" />
                    </div>
                    <div class="news-content">
                        <h3 class="title mb-2">{{ item.title | translate }}</h3>
                        <p class="desc mb-2">{{ item.desc | translate }}</p>
                        <p class="read-more mb-1">{{ "news.read_more" | translate }}</p>
                        <span class="date">{{ item.date | translate }}</span>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <!-- Mobile version -->
    <div *ngIf="isRender && isMobile" class="mt-4">
        <div class="d-flex align-items-stretch media-wrapper ">

            <a (click)="openNewsUrl(item.link)" *ngFor="let item of items; let i = index" class="news-box"
                [href]="item.link" target="_blank" rel="noopener noreferrer">
                <div class="news-img mb-3">
                    <img [src]="item.img" alt="news image" class="img-fluid" loading="lazy" />
                </div>
                <div class="news-content">
                    <h3 class="title mb-2">{{ item.title | translate }}</h3>
                    <p class="desc mb-2">{{ item.desc | translate }}</p>
                    <p class="read-more mb-1">{{ "news.read_more" | translate }}</p>
                    <span class="date">{{ item.date | translate }}</span>
                </div>
            </a>

        </div>
    </div>

</section>